import ApexTreeSelect from './src/index'

ApexTreeSelect.install = function(Vue) {
  Vue.component(ApexTreeSelect.name, ApexTreeSelect)
}

export default ApexTreeSelect
